var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeCrossed1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_62_235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2668 9.40839C22.3644 7.93064 21.2261 6.61066 19.8971 5.50084L22.696 2.70189C23.0796 2.30477 23.0685 1.67196 22.6714 1.28843C22.284 0.914273 21.6699 0.914273 21.2825 1.28843L18.2386 4.33628C16.3517 3.21554 14.1946 2.63137 12 2.64693C5.81126 2.64693 2.28457 6.88337 0.733158 9.40843C-0.244386 10.9895 -0.244386 12.9874 0.733158 14.5685C1.63559 16.0463 2.7739 17.3663 4.10292 18.4761L1.30398 21.275C0.906859 21.6586 0.895847 22.2914 1.27938 22.6885C1.66291 23.0856 2.29577 23.0966 2.69284 22.7131C2.70118 22.705 2.70938 22.6968 2.71744 22.6885L5.76829 19.6376C7.65285 20.7582 9.80746 21.3433 12 21.33C18.1887 21.33 21.7154 17.0935 23.2668 14.5685C24.2444 12.9874 24.2444 10.9895 23.2668 9.40839ZM6.00225 11.9885C5.99658 8.68148 8.67276 5.99607 11.9797 5.9904C13.231 5.98825 14.4515 6.37815 15.4697 7.10529L14.0183 8.55675C13.4089 8.18929 12.7116 7.99343 12 7.98996C9.79172 7.98996 8.00152 9.78015 8.00152 11.9885C8.00499 12.7 8.20086 13.3974 8.56831 14.0067L7.11685 15.4582C6.39206 14.4464 6.0023 13.233 6.00225 11.9885ZM12 17.9862C10.7554 17.9862 9.54211 17.5964 8.53031 16.8716L9.98177 15.4202C10.5911 15.7876 11.2885 15.9835 12 15.987C14.2083 15.987 15.9985 14.1968 15.9985 11.9885C15.9951 11.2769 15.7992 10.5795 15.4317 9.97021L16.8832 8.51875C18.805 11.21 18.1812 14.9496 15.49 16.8714C14.4718 17.5985 13.2513 17.9884 12 17.9862Z",
    fill: "#A7B7DD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_62_235"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeCrossed1);
export default __webpack_public_path__ + "static/media/eye-crossed 1.b7157bffa19528647261c453f040f934.svg";
export { ForwardRef as ReactComponent };